import { useEffect, useState } from "react"
import { Footer } from "../../layout/footer";

import { ShehaContent } from "../../components/dashboard"

export default function Dashboard () {

  return (
    <>
        <ShehaContent/>  
    </>
  )

}